let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3WDCt")).then(() => parcelRequire('89Ehy'));